import { render, staticRenderFns } from "./SetApproveStatus.vue?vue&type=template&id=455d6026&"
import script from "./SetApproveStatus.vue?vue&type=script&lang=js&"
export * from "./SetApproveStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports